<div class="loginWraper card" *ngIf="!submitted">
      <form [formGroup]="delete_memeberform">
          <div class="form-group">
              <input type="text" class="form-control" placeholder="મોબાઇલ નંબર" formControlName="contact_no"  maxlength="15" />             
              <div *ngIf="submitted && f.contact_no.errors" class="error-message">
                  <small *ngIf="f.contact_no.errors?.required" class="text-danger">સંપર્ક નંબર જરૂરી છે.</small>
              </div>
              <div *ngIf="f.contact_no.errors?.pattern && f.contact_no.touched" class="error-message">
                  <small *ngIf="f.contact_no.errors?.pattern" class="text-danger">માત્ર નંબર જ માન્ય છે.</small>
              </div>
              <div *ngIf="f.contact_no.errors?.minlength && f.contact_no.touched" class="error-message">
                  <small *ngIf="f.contact_no.errors?.minlength" class="text-danger">ઓછામાં ઓછા 7 નંબર જરૂરી
                      છે.</small>
              </div>
          </div>
          <button type="submit" class="btn-common" (click)="submit()">એકાઉન્ટ કાઢી નાખો</button>
      </form>
  </div>

<div class="card" *ngIf="submitted">
      <div class="m-auto text-center">
            <i class="checkmark">✓</i>
            <h1>સફળતા</h1>
            <p>અમે પ્રગતિમાં છીએ, <br /> અમે ટૂંક સમયમાં તમારું એકાઉન્ટ નિષ્ક્રિય કરીશું.</p>
      </div>
</div>